import React from 'react';
// import { Link } from 'react-router-dom';
import { Card, Button } from 'antd';
import moment from 'moment';

const PopupContent = ({ dData, dId, deviceMaps }) => {
    // console.log('dId=>', dId, dData);
    let deviceId = dId;
    if (dId.includes('-')) {
        const [deviceImei, _] = dId.split('-');
        deviceId = deviceImei;
    }
    return (
        <div style={{ width: '600px !important' }}>
            <Card style={{ width: '100%' }}>
                <div
                    style={{
                        width: '100%',
                        maxHeight: '200px',
                        overflowY: 'scroll',
                        marginBottom: '10px',
                    }}
                >
                    <div key={'time'} className="gx-media gx-align-items-center gx-flex-nowrap gx-pro-contact-list">
                        <div className="gx-mr-3">
                            <img alt="..." src={require('assets/images/icon/timestamp.png')} />
                        </div>
                        <div className="gx-media-body">
                            <span className="gx-mb-0 gx-text-grey gx-fs-sm">
                                Time : {moment(dData.timestamp).toLocaleString()}
                            </span>
                        </div>
                    </div>
                    <div key={'status'} className="gx-media gx-align-items-center gx-flex-nowrap gx-pro-contact-list">
                        <div className="gx-mr-3">
                            <img alt="..." src={require(`assets/images/icon/${dData.status}.png`)} />
                        </div>
                        <div className="gx-media-body">
                            <span className="gx-mb-0 gx-text-grey gx-fs-sm">Status: {dData.status}</span>
                        </div>
                    </div>
                    {/* <div key={'battery'}
                        className="gx-media gx-align-items-center gx-flex-nowrap gx-pro-contact-list">
                        <div className="gx-mr-3">
                            <img alt="..." src={require('assets/images/icon/battery.png')}
                                className="" />
                        </div>
                        <div className="gx-media-body">
                            <span
                                className="gx-mb-0 gx-text-grey gx-fs-sm">Battery Voltage : {dData && dData.bat_vol || '-'}</span>
                        </div>
                    </div> */}
                    {/* <div key={'fuel'}
                        className="gx-media gx-align-items-center gx-flex-nowrap gx-pro-contact-list">
                        <div className="gx-mr-3">
                            <img alt="..." src={require('assets/images/icon/fuel.png')}
                                className="" />
                        </div>
                        <div className="gx-media-body">
                            <span
                                className="gx-mb-0 gx-text-grey gx-fs-sm">Fuel Level : {dData && dData.fuel_level || '-'}</span>
                        </div>
                    </div> */}
                    {/* <div key={'speed'}
                        className="gx-media gx-align-items-center gx-flex-nowrap gx-pro-contact-list">
                        <div className="gx-mr-3">
                            <img alt="..." src={require('assets/images/icon/speed.png')}
                                className="" />
                        </div>
                        <div className="gx-media-body">
                            <span
                                className="gx-mb-0 gx-text-grey gx-fs-sm gx-text-hover">Speed : {dData.speed}</span>
                        </div>
                    </div> */}
                    {/* <div key={'counter'}
                        className="gx-media gx-align-items-center gx-flex-nowrap gx-pro-contact-list">
                        <div className="gx-mr-3">
                            <img alt="..." src={require('assets/images/icon/counter.png')}
                                className="" />
                        </div>
                        <div className="gx-media-body">
                            <span
                                className="gx-mb-0 gx-text-grey gx-fs-sm">Meter : {dData && dData.meter || '-'}</span>
                        </div>
                    </div> */}
                    {/* <div key={'temp'}
                        className="gx-media gx-align-items-center gx-flex-nowrap gx-pro-contact-list">
                        <div className="gx-mr-3">
                            <img alt="..." src={require('assets/images/icon/temperature.png')}
                                className="" />
                        </div>
                        <div className="gx-media-body">
                            <span
                                className="gx-mb-0 gx-text-grey gx-fs-sm">Temperature : {dData && dData.engine_temp || '-'}</span>
                        </div>
                    </div>
                    <div key={'rpm'}
                        className="gx-media gx-align-items-center gx-flex-nowrap gx-pro-contact-list">
                        <div className="gx-mr-3">
                            <img alt="..." src={require('assets/images/icon/rpm.png')}
                                className="" />
                        </div>
                        <div className="gx-media-body">
                            <span
                                className="gx-mb-0 gx-text-grey gx-fs-sm">RPM : {dData && dData.engine_rpm || '-'}</span>
                        </div>
                    </div> */}
                </div>
                {/* <Button style={{ marginBottom: 0 }} type={'primary'} size={'small'}>
                    <Link to={`iot/device-details/${deviceMaps.has(dId) ? deviceMaps.get(dId)['_id'] : ''}/${dId}`}>Details</Link>
                </Button> */}
                <Button style={{ marginBottom: 0 }} type={'primary'} size={'small'}>
                    <a target='_blank' href={`/iot/device-details/${deviceMaps.has(dId) ? deviceMaps.get(dId)['_id'] : ''}/${deviceId}`}>
                        Details
                    </a>
                </Button>
            </Card>
        </div>
    );
};

export default PopupContent;